// extracted by mini-css-extract-plugin
module.exports = {"rectangle":"innerpage_rectangle__bl66d","image":"innerpage_image__1sw71","titleText":"innerpage_titleText__2Q--3","carousal":"innerpage_carousal__1S6h5"};